import { render } from "./StudentRequirementsDialog.vue?vue&type=template&id=b34923cc&scoped=true"
import script from "./StudentRequirementsDialog.vue?vue&type=script&lang=js"
export * from "./StudentRequirementsDialog.vue?vue&type=script&lang=js"

import "./StudentRequirementsDialog.vue?vue&type=style&index=0&id=b34923cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b34923cc"]])

export default __exports__